<template>
    <div :key="componentKey" class="upload" v-show="this.$store.state.currentUser !== null">
        <button class="btn green uploadBtn icon-left" @click="$refs.inputFile.click(id)" :disabled="loading">
            <ion-icon name="cloud-upload"></ion-icon>
            <span>{{ status }} <div v-show="loading" class="loading small no-margin"></div></span>
        </button>
        <input
            hidden
            type="file"
            ref="inputFile"
            multiple="false"
            class="input-file"
            accept="image/*"
            @change="addFile($event, id)"
        >
    </div>
</template>

<script>
    const fb = require('../firebaseConfig.js')
    import moment from 'moment'

    export default {
        data(){
            return{
                status: 'Upload',
                loading: false,
                componentKey: 0
            }
        },
        props: [
            'id'
        ],
        methods: {
            fileExtension (file) {
                let reversed = file.name.split('').reverse().join('')
                reversed = reversed.split('.')[0]
                return reversed.split('').reverse().join('')
            },
            ValidateSize(file){
                var FileSize = file.files[0].size / 1024 / 1024; // in MB
                if (FileSize > 4) {
                    alert('Please upload file size under 4 MB.');
                    return false
                } else {
                    return true
                }
            },
            addFile (ev, id) {
                
                let self = this

                if(!self.ValidateSize(ev.target)) return

                const ext = this.fileExtension(ev.target.files[0])
                const type = ev.target.files[0].type
                const file = new File([ev.target.files[0]], `${new Date().getTime()}.${ext}`, { type })
                
                self.$emit('file', file)
                self.loading = true
                self.status = 'Uploading'
                
                console.log('Sending '+ file.name + ' to storage')

                let fileRef = fb.storage.ref().child(`files/${id}/${file.name}`)
                let eventRef = fb.eventsCollection.doc(id).collection('files').doc()

                fileRef.put(file).then(snapshot => {
                    snapshot.ref.getDownloadURL().then(url => {
                        
                        let photoData = {
                            url: url,
                            name: file.name,
                            author: self.$store.state.currentUser.uid,
                            timestamp: moment().unix()
                        }

                        eventRef.set(photoData).then(() => {
                            
                            self.$emit('fileOk', file)
                            self.loading = false
                            self.status = 'Upload'                      
                            self.$emit('uploadSuccess')

                            console.log('Finished uploading ', file.name, url)

                            self.resetBtn()

                        }).catch(err => {
                            console.log('Error saving file: ', err.message)
                            self.loading = false
                            self.status = 'Error Occurred'
                            self.resetBtn()
                        })
                    }).catch(err => {
                        console.log('File put error: ', err.message)
                        self.loading = false
                        self.status = 'Error Occurred'
                        self.resetBtn()
                    })
                }).catch(err => {
                    console.log('Upload file error: ', err.message)
                    self.loading = false
                    self.status = 'Error Occurred'
                    self.resetBtn()
                })

                self.$refs.inputFile.value = null
            },
            resetBtn(time){
                
                let resetTime = time ? time : 0

                setTimeout(function(){
                    this.loading = false
                    this.status = 'Upload'
                }, resetTime)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Upload.vue